module.exports = __webpack_public_path__ + "static/media/bed.5e16f981.svg";